import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import { RegState } from "../../model";
import { url } from "../../utils/config";
import { serverMessage } from "../../utils/serverMessage";
import { delayMessage } from "../../utils/delayMessage";

const initialState: RegState = {
  isLoading: false, // to control loading content in reg btn
  isDisable: false, // to disable btn until request is complete
  user: {
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "",
  },
  pendingRequestTimer: null,
};

export const reg = createAsyncThunk(
  "register/reg",
  async (details: any, thunkAPI) => {
    const { user, setToggleReg } = details;

    try {
      const { data } = await axios.post(`${url.baseUrl}/register`, user);

      setTimeout(() => {
        // Timeout to navigate to login when user is authenticated
        toast.success("Please Login");
        setToggleReg(true);
      }, 2000);

      return data;
    } catch (error: any) {
      console.log(error.response.data.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const regSlice = createSlice({
  name: "reg",
  initialState,
  reducers: {
    // Collect input values on the reg page
    getRegValues: (
      state,
      { payload }: PayloadAction<{ name: keyof RegState; value: any }>
    ) => {
      const { name, value } = payload;
      state.user = { ...state.user, [name]: value };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(reg.pending, (state) => {
        state.isLoading = true;
        state.isDisable = true;
        state.pendingRequestTimer = setTimeout(delayMessage, 10000);
      })
      .addCase(reg.fulfilled, (state, { payload }) => {
        toast.success(payload.data.message);
        state.isLoading = false;
        state.isDisable = false;
        state.user.firstName = "";
        state.user.lastName = "";
        state.user.username = "";
        state.user.email = "";
        state.user.password = "";
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      })
      .addCase(reg.rejected, (state, { payload }) => {
        serverMessage(payload);
        state.isLoading = false;
        state.isDisable = false;
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      });
  },
});

export default regSlice.reducer;

export const { getRegValues } = regSlice.actions;
